import { atom, selector } from 'recoil';
import { EventReceptions, GetDetailEventDtoRx } from '@/sdk/data-contracts';

export const eventListRecoil = atom<EventReceptions[] | null>({
  key: 'eventListRecoil',
  default: null,
});

export const eventDetailRecoil = atom<GetDetailEventDtoRx | null>({
  key: 'eventDetailRecoil',
  default: null,
});

export const eventDetailIdRecoil = atom<number | null>({
  key: 'eventDetailIdRecoil',
  default: null,
});
